import { render, staticRenderFns } from "./cascadeRegion.vue?vue&type=template&id=806be49c&scoped=true"
import script from "./cascadeRegion.vue?vue&type=script&lang=js"
export * from "./cascadeRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806be49c",
  null
  
)

export default component.exports